import React from "react";
import PropTypes from "prop-types";
import { Waiting } from "components/ui";
import { formatDuration, formatPercent, getScoreBadgeClass } from "./call-quality-utils";

const AggregationTable = ({ data, isFetching, nameLabel, emptyMessage, onNameClick }) => {
  if (isFetching) {
    return <Waiting />;
  }

  if (!data || data.length === 0) {
    return (
      <div className="no-data-message">
        {emptyMessage || `No ${nameLabel.toLowerCase()} quality data found for the selected filters.`}
      </div>
    );
  }

  return (
    <div className="aggregation-table-container">
      <table className="data-table aggregation-table">
        <thead>
          <tr>
            <th>{nameLabel}</th>
            <th>Total Calls</th>
            <th>Avg Score</th>
            <th>Positive Sentiment Rate</th>
            <th>Excellent Calls (90%+)</th>
            <th>Avg Duration</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={item.id}>
              <td>
                {onNameClick && item.id ? (
                  <button
                    className="link-button"
                    onClick={() => onNameClick(item.id)}
                    title={`Filter dashboard to this ${nameLabel.toLowerCase()}`}
                  >
                    {item.name || "-"}
                  </button>
                ) : (
                  item.name || "-"
                )}
              </td>
              <td>{item.totalCalls || 0}</td>
              <td>
                <span className={`score-badge ${getScoreBadgeClass(item.averageScore)}`}>
                  {formatPercent(item.averageScore)}
                </span>
              </td>
              <td>{formatPercent(item.positiveSentimentRate)}</td>
              <td>{item.excellentCalls || 0}</td>
              <td>{formatDuration(item.averageDurationSeconds)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

AggregationTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      totalCalls: PropTypes.number,
      averageScore: PropTypes.number,
      positiveSentimentRate: PropTypes.number,
      excellentCalls: PropTypes.number,
      averageDurationSeconds: PropTypes.number
    })
  ),
  isFetching: PropTypes.bool,
  nameLabel: PropTypes.string.isRequired,
  emptyMessage: PropTypes.string,
  onNameClick: PropTypes.func
};

export default AggregationTable;
